import type { CardButtonAction } from "./offer";
import type { MemberPurchaseFlags, MemberSource } from "./purchase.types";

/** 卡片动作到旧支付入口标记的唯一映射；试用优先级由 purchaseIntent 处理。 */
export const MEMBER_ACTION_FLAGS = {
  new: { skipUpgrade: false, forceUpgrade: false, subscribePlan: false },
  renew: { skipUpgrade: true, forceUpgrade: false, subscribePlan: false },
  subscribe: { skipUpgrade: false, forceUpgrade: true, subscribePlan: true },
  upgrade: { skipUpgrade: false, forceUpgrade: true, subscribePlan: false },
  blocked: { skipUpgrade: true, forceUpgrade: false, subscribePlan: false }
} as const satisfies Record<CardButtonAction, MemberPurchaseFlags>;

export const UPGRADE_TRACK_BUTTON: Record<MemberSource, string> = {
  powerPage: "member_upgrade",
  vipPackage: "button_member_upgrade",
  powerTop: "member_upgrade_top"
};
